import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Row, Col, Button, Modal, Drawer, Tooltip, message, Divider } from 'antd';
import { LeftOutlined, RedoOutlined, DeleteOutlined } from '@ant-design/icons';
import { isEmpty, find } from 'lodash';

import {
    loadIncidentDetails, updateIncidentDetails, deleteIncident
} from '../actions';
import * as constants from '../constants';
import IncidentForm from './IncidentForm';

import common from '../../../common';
import currentuser from '../../currentuser';
import core from '../../core';
import globalappstate from '../../globalappstate';
import uistate from '../../uistate';
import dossier from '../../dossier';

class IncidentDetails extends Component {

    state = {
        selectedIdIncident: '',
        refreshcount: 0,
    }

    UNSAFE_componentWillMount() {
        if (this.props.repId) { //render als popup
            this.setState({
                selectedIdIncident: this.props.repId,
            },
                () => this.refreshDetailIncident());
        } else { //render as page (url)
            //console.log('as page url', this.props);
            this.setState({
                selectedIdIncident: this.props.match.params.repId,
            },
                () => this.refreshDetailIncident());
        }
    }

    refreshDetailIncident = async () => {
        let incident = await this.props.loadIncidentDetails(this.state.selectedIdIncident);
        await this.props.loadDossierFiles(incident.idDossier);
    }

    refreshIncident = async => {
        if (this.props.selectedDetailIncidentIsDirty) {
            if (window.confirm(this.label("UnsavedChanges"))) {
                this.setState(state => ({
                    refreshcount: state.refreshcount + 1,
                }));
                this.refreshDetailIncident();
            }
        } else {
            this.setState(state => ({
                refreshcount: state.refreshcount + 1,
            }));
            this.refreshDetailIncident();
        }
    }

    deleteIncident = async () => {
        if (window.confirm(this.label("DeleteConfirm"))) {
            await this.props.deleteIncident(this.state.selectedIdIncident);
            this.props.history.goBack();
        }
    }

    saveClicked = async (incident) => {
        await this.props.updateIncidentDetails(incident);
        await this.refreshDetailIncident()
        this.setState({ selectedIdIncident: incident.idIncident })
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'IncidentDetails', key);
    }

    navigateBack = async () => {
        this.props.history.goBack();
    }

    render() {
        const menuHeight = 45;
        const gridHeight = this.props.contentHeight - menuHeight;

        let showform = !isEmpty(this.props.picklists) && !isEmpty(this.props.selectedDetailIncident);

        return (
            <div className='incident' >
                <Row className='main-toolbar' style={{ height: menuHeight }} justify="start" align='middle' gutter={8}>
                    <Col >
                        <Button size='small' type="primary" onClick={this.navigateBack} style={{ marginLeft: 15, marginRight: 15 }} >
                            <LeftOutlined />{this.props.expId ? this.label("Close") : this.label("Back")}
                        </Button>

                        <span className='module-title'>{this.label("IncidentDetails")}</span>
                        <Button size='small' onClick={this.refreshIncident} style={{ marginLeft: 25 }} >
                            <RedoOutlined />{this.label("RefreshIncident")}
                        </Button>
                        <Button size='small' type="primary" onClick={this.deleteIncident} style={{ marginLeft: 25 }} >
                            <DeleteOutlined />{this.label("DeleteIncident")}
                        </Button>
                    </Col>
                </Row>

                <Spin size="large" spinning={this.props.loadingDetails}>
                    {showform &&
                        <IncidentForm key={`${this.props.selectedDetailIncident.idIncident}:${this.state.refreshcount}`}
                            contentheight={gridHeight}
                            datacontext={this.props.selectedDetailIncident}
                            contentHeight={this.props.contentHeight} contentWidth={this.props.contentWidth}
                            onSave={this.saveClicked}
                            onRefresh={this.refreshReport} onCancel={this.refreshReport} onRedirect={this.navigateBack} />
                    }
                </Spin>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedDetailIncident: state[constants.NAME].selectedDetailIncident,
        loadingDetails: state[constants.NAME].loadingDetails,
        contentHeight: state[uistate.constants.NAME].contentheight,
        contentWidth: state[uistate.constants.NAME].contentwidth,
        labels: uistate.selectors.uiLabels(state),
        selectedDetailIncidentIsDirty: state[constants.NAME].selectedDetailIncidentIsDirty,
        picklists: globalappstate.selectors.allPicklists(state),
        currentuser: state[currentuser.constants.NAME],
    };
}

export default connect(mapStateToProps,
    {
        loadIncidentDetails, updateIncidentDetails, deleteIncident,
        loadDossierFiles: dossier.actions.loadDossierFiles
    })(IncidentDetails);